import { render, staticRenderFns } from "./NativeBar.vue?vue&type=template&id=a80710b0&scoped=true&"
import script from "./NativeBar.vue?vue&type=script&lang=js&"
export * from "./NativeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80710b0",
  null
  
)

export default component.exports